// Ant Design 6 theme tokens. Светлая и тёмная схема через algorithm.
import { theme as antdTheme, type ThemeConfig } from "antd";

const baseToken = {
  colorPrimary: "#1677ff",
  borderRadius: 6,
  fontSize: 14,
};

export function buildThemeConfig(isDark: boolean): ThemeConfig {
  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: baseToken,
    components: {
      Layout: {
        // Чтобы header корректно контрастировал на обеих схемах.
        headerBg: isDark ? "#001529" : "#ffffff",
      },
    },
  };
}
